import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const BuildingMaterialSuppliers = ({ location }) => {
    debugger
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                {/* First Row */}
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/building-supplies-1-1024x683.jpg" alt="Building Supplies 1" />
                    </div>
                    <div className="col-lg-6 content">
                            <h1 className="elementor-heading-title elementor-size-default">
                                Building Material Suppliers Software {state.condText}
                        </h1>
                    </div>
                </div>

                <br />

                {/* Second Row */}
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <h2 className="elementor-heading-title elementor-size-default">
                            To remain competitive in the Building Supplies industry,
                        </h2>
                        <p style={{ fontWeight: 400 }}>
                            High quality and compliant products need to be supplied efficiently and cost effectively. With increasing pressure
                            from cheaper, international suppliers, it�s never been more important to have complete visibility of your supply
                            chain from ordering right through to supply, and to be able to respond to the needs of your customers at each and
                            every touch point.
                        </p>
                    </div>
                    <div className="col-lg-6 content">
                        <img src="/theme/img/building-supplies-2-768x512.jpg" alt="Building Supplies 2" />
                    </div>
                </div>

                <br />

                {/* Third Row */}
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/bdimg5.JPG" alt="Building Supplies" />
                    </div>
                    <div className="col-lg-6 content">
                        <h2 className="elementor-heading-title elementor-size-default">
                            To help you stay competitive, we offer solutions that work from different angles to address the varying needs of
                            your business.
                        </h2>
                        <p style={{ fontWeight: 400 }}>
                            Efficiency is driven from within by the Tejaxo ERP Manufacturing Management which completely automates your workflows.
                            Our Supply Chain module helps ensure incoming and outgoing goods are delivered efficiently and intelligently while
                            our BI reporting gives you visibility of your entire production, providing insights to allow the right decisions to
                            be made in real time.
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default BuildingMaterialSuppliers;